import tabtalk from '@shared/utils/tabtalk'
import Cookies from 'js-cookie'
import { short } from '@shared/utils/uuid'
import snakeCase from 'lodash/snakeCase'

const UUID = short()

export const tabOnly = (uniqueName: string, fn: (...args: any[]) => any) => {
  const NAME = snakeCase(uniqueName).toUpperCase()
  const SETUP_CHECKING = `SETUP_CHECKING_${NAME}`
  const SETUP_CHECKING_FEEDBACK = `SETUP_CHECKING_FEEDBACK_${NAME}`

  const setUUID = () => Cookies.set(`TAB_ONLY_${NAME}_UUID`, UUID)
  const getUUID = () => Cookies.get(`TAB_ONLY_${NAME}_UUID`)

  tabtalk.$on(SETUP_CHECKING, () => {
    if (getUUID() !== UUID) {
      return
    }
    tabtalk.$broadcast(SETUP_CHECKING_FEEDBACK)
  })

  const run = () => {
    if (getUUID() === UUID) {
      return
    }

    tabtalk.$emit(SETUP_CHECKING)

    const execute = () => {
      setUUID()
      fn()
    }

    // 空值直接执行
    if (getUUID() === undefined) {
      execute()
      return
    }

    // 超时执行
    const selfCheckingTimer = setTimeout(execute, 3000)

    // 等待回应, 有回应就清除掉
    tabtalk.$once(SETUP_CHECKING_FEEDBACK, () => {
      clearTimeout(selfCheckingTimer)
    })
  }

  // 手动检测
  run()

  // 启动定时检测
  setInterval(run, 2 * 60 * 1000)
}
